export default "/9170b1db32e4eabe1c030aaea6e0802d.jpg";